import ImageBanner from "./ImageBanner";
import OverlappingCard from "./OverlappingCard";

interface Props {
  bannerSrc: string;
  cardTitle: string;
  children: React.ReactNode;
}

export default function LayoutBanner({
  bannerSrc,
  cardTitle,
  children,
}: Props) {
  return (
    <div className="w-full ">
      <ImageBanner src={bannerSrc} />
      <OverlappingCard title={cardTitle} />
      <div className="text-[#102542] space-y-16 flex flex-col items-center justify-center">
        {children}
      </div>
    </div>
  );
}
